import { render, staticRenderFns } from "./Trend.vue?vue&type=template&id=566c702c&scoped=true"
import script from "./Trend.vue?vue&type=script&lang=js"
export * from "./Trend.vue?vue&type=script&lang=js"
import style0 from "./Trend.vue?vue&type=style&index=0&id=566c702c&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "566c702c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('566c702c')) {
      api.createRecord('566c702c', component.options)
    } else {
      api.reload('566c702c', component.options)
    }
    module.hot.accept("./Trend.vue?vue&type=template&id=566c702c&scoped=true", function () {
      api.rerender('566c702c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chart/Trend.vue"
export default component.exports